import React from 'react';

import { Section } from '@gogame/components';
import { FormField } from '@gogame/form';

import {
  AFFECTED_LEVEL,
  GENERAL,
  SECONDARY_AFFECTED_LEVEL,
} from 'scenes/SmartRules/SmartRuleForm/General/constants';
import { loadExtraMetrics } from 'scenes/SmartRules/sources/fields';

import { EXTRA_METRICS } from './constants';

export const ExtraMetricsSection = () => {
  return (
    <Section title={'Extra Metrics to Results'}>
      <FormField.MultiSelect
        label={'Extra Metrics to include in the Results'}
        placeholder={'Select metrics'}
        name={EXTRA_METRICS}
        groupBy={'category'}
        source={loadExtraMetrics}
        depends={[
          `${GENERAL}.${AFFECTED_LEVEL}`,
          `${GENERAL}.${SECONDARY_AFFECTED_LEVEL}`,
        ]} //metricIdsToExclude
        lazy={true}
        padding={0}
      />
    </Section>
  );
};
